import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=b84298e0&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=b84298e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84298e0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./template/accueil/components/Loading.vue
// module id = 944
// module chunks = 0